import { amplifiedReflectionDescent } from './entries/amplified-reflection-descent';
import { behaviouralRehearsal } from './entries/behavioural-rehearsal';
import { careTeamWillingness } from './entries/care-team-willingness';
import { coreMotivation } from './entries/core-motivation';
import { desiredStateElicitation } from './entries/desired-state-elicitation';
import { developDiscrepancy } from './entries/develop-discrepancy';
import { doubleSidedReflection } from './entries/double-sided-reflection';
import { framingOffer } from './entries/framing-offer';
import { functionOfUseDescent } from './entries/function-of-use-descent';
import { functionalAnalysis } from './entries/functional-analysis';
import { guidedExploration } from './entries/guided-exploration';
import { normativeFeedback } from './entries/normative-feedback';
import { practicalPlanning } from './entries/practical-planning';
import { readinessElicitation } from './entries/readiness-elicitation';
import { reasonsForChange } from './entries/reasons-for-change';
import { resultsBasedAccountability } from './entries/results-based-accountability';
import { sitWithDiscouragement } from './entries/sit-with-discouragement';
import { sleepAndCravings } from './entries/sleep-and-cravings';
import { socialMoments } from './entries/social-moments';
import { stressCravingCycle } from './entries/stress-craving-cycle';
import { typicalDayWalkthrough } from './entries/typical-day-walkthrough';
import { urgeSurfing } from './entries/urge-surfing';
import { yourDays } from './entries/your-days';
import { yourWorldWalkthrough } from './entries/your-world-walkthrough';
import type { TechniqueEntry } from './schema';

export * from './schema';
export { scanTechniqueCatalogue, scanTechniqueEntry, sonaFacingStringFields } from './scanner';

// The bundled technique catalogue — repo source compiled into the Lambda
// bundle by ordinary import: in memory before the first request, no runtime
// fetch, no DB dependency; merge → deploy is the content update path. Keyed by
// entry key; validated (schema + scanner) by the co-located test suite, not a
// runtime throw — mirroring the programs seed precedent.
export const TECHNIQUE_CATALOGUE: Readonly<Record<string, TechniqueEntry>> = {
  typical_day_walkthrough: typicalDayWalkthrough,
  function_of_use_descent: functionOfUseDescent,
  desired_state_elicitation: desiredStateElicitation,
  double_sided_reflection: doubleSidedReflection,
  develop_discrepancy: developDiscrepancy,
  amplified_reflection_descent: amplifiedReflectionDescent,
  framing_offer: framingOffer,
  sit_with_discouragement: sitWithDiscouragement,
  readiness_elicitation: readinessElicitation,
  reasons_for_change: reasonsForChange,
  your_world_walkthrough: yourWorldWalkthrough,
  normative_feedback: normativeFeedback,
  care_team_willingness: careTeamWillingness,
  practical_planning: practicalPlanning,
  urge_surfing: urgeSurfing,
  functional_analysis: functionalAnalysis,
  behavioural_rehearsal: behaviouralRehearsal,
  stress_craving_cycle: stressCravingCycle,
  social_moments: socialMoments,
  sleep_and_cravings: sleepAndCravings,
  your_days: yourDays,
  results_based_accountability: resultsBasedAccountability,
  core_motivation: coreMotivation,
  guided_exploration: guidedExploration,
};
